import { memoize } from 'lodash'

const PreOrdersItemViewModel = memoize((lineItem) => {
  return {
    id: lineItem.menuItemUuid,
    name: lineItem.name,
    price: `$${lineItem.price}`,
    color: null,
    priceInCents: parseInt(lineItem.price.replace('.', '')),
    lineItemUuid: lineItem.uuid,
    quantity: lineItem.quantity,
  }
})

export default PreOrdersItemViewModel
